import React ,{useContext} from 'react'
import { HeroContext } from './App';
export default function SupermanItem(props) {
    const {handleUpdateGoods}=useContext(HeroContext)
    const {item,value}=props
    return (
        <div>
            <p>
                superman {item} 
                <button
                onClick={()=>{
                    handleUpdateGoods('superman',{[item]:Number([value])-1})
                }}
                >
                    -
                </button>
                <span> {value}</span>
                <button
                onClick={()=>{
                    handleUpdateGoods('superman',{[item]:Number([value])+1})
                }}
                >
                     +
                </button>
            </p>  
        </div>
    )
}

